export default "/assets/website/images/stuhmer_favicon.png?a90f77432e5489c767807c195092d2e5";